import React, { useState, useRef } from 'react';
import { api, resolveImg } from '../../api';
import { Upload, Loader2 } from 'lucide-react';

const ImageUploader = ({ value, onChange, label = 'Image' }) => {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', f);
      const r = await api.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(r.data.url);
    } catch (err) {
      alert('Upload échoué: ' + (err?.response?.data?.detail || err.message));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div>
      <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275]">{label}</span>
      <div className="mt-2 flex items-start gap-4">
        <div className="w-28 h-28 bg-[#FAF8F4] border border-[#E8E2D5] overflow-hidden flex items-center justify-center shrink-0">
          {value ? (
            <img src={resolveImg(value)} alt="" className="w-full h-full object-cover" />
          ) : (
            <span className="text-[10px] text-[#8A8275] tracking-widest uppercase">Aucune</span>
          )}
        </div>
        <div className="flex-1">
          <input type="file" accept="image/*" ref={inputRef} onChange={onFile} className="hidden" id={`up-${label}`} />
          <label htmlFor={`up-${label}`} className="btn-ghost cursor-pointer inline-flex" style={{ padding: '10px 18px' }}>
            {uploading ? <><Loader2 size={14} className="animate-spin" /> Envoi…</> : <><Upload size={14} /> Téléverser</>}
          </label>
          <input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder="… ou coller une URL" className="mt-2 w-full bg-[#FAF8F4] border border-[#E8E2D5] focus:border-[#957340] outline-none p-2 text-[12px]" />
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
